import { NomenclatureUnitComposition } from '../nomenclature-unit-composition';

export class NomenclatureUnitCompositionResponse {
    public composition?: NomenclatureUnitComposition[];

    constructor(data?: Partial<NomenclatureUnitCompositionResponse>) {
        this.composition = data?.composition;
    }
}
